import { render } from "./OuterTop.vue?vue&type=template&id=0f7b96ac&scoped=true&ts=true"
import script from "./OuterTop.vue?vue&type=script&lang=ts"
export * from "./OuterTop.vue?vue&type=script&lang=ts"

import "./OuterTop.vue?vue&type=style&index=0&id=0f7b96ac&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2791644585/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7b96ac"]])

export default __exports__